import { render, staticRenderFns } from "./LegacyListArticleItem.vue?vue&type=template&id=1708e65f&scoped=true"
import script from "./LegacyListArticleItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegacyListArticleItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LegacyListArticleItem.vue?vue&type=style&index=0&id=1708e65f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1708e65f",
  null
  
)

export default component.exports